import { getUsersByEmailsOptions } from "@pulse/api/queryApi";
import { useParticipantSearch } from "../hooks";
import { CsvButton } from "./BulkParticipant/CsvUpload";
import { ParticipantSearchField } from "./ParticipantSearchField";
import ParticipantSelector from "./ParticipantSelector/ParticipantSelector";
import { useEmailImport } from "./useEmailImport";
import { useTranslation } from "react-i18next";
import { useCurrentCustomerId } from "@pulse/hooks/useCustomerId";

export function ParticipantField() {
    const { t } = useTranslation();
    const customerId = useCurrentCustomerId();
    const { inputRef } = useParticipantSearch();
    const { importCsvText } = useEmailImport(customerId || 0, getUsersByEmailsOptions);
    return (
        <>
            <div className="w-full col-span-2">
                <p className="pb-3">{t("participantField.instructions")}</p>
                <ParticipantSearchField />

                <ParticipantSelector />
            </div>
            <CsvButton
                onCsvImported={async (emails) => {
                    await importCsvText(emails.join(","));
                    inputRef.current?.focus();
                }}
            />
        </>
    );
}
